import { post } from '../axios'

// 根据多语言KEY精准查询
export function search_key_post(map, option) {
  return post(`${process.env.VUE_APP_I18N}/search/key`, map, option).then(
    response => response
  )
}

// 根据多语言KEY精准查询文案
export function search_value_post(map, option) {
  return post(`${process.env.VUE_APP_I18N}/search/value`, map, option).then(
    response => response
  )
}
